import React from 'react'
import HeroSection from './HeroSection'

export default function HomeView() {
	return (
		<div className='min-h-screen md:h-screen flex flex-col bg-background text-foreground'>
			<HeroSection />
		</div>
	)
}
